import { ExternalToast, toast } from 'sonner';

export class ToasterUtil {
  private static _instance: ToasterUtil;

  static get instance(): ToasterUtil {
    if (!ToasterUtil._instance) {
      ToasterUtil._instance = new ToasterUtil();
    }

    return ToasterUtil._instance;
  }

  close(id: string): void {
    toast.dismiss(id);
  }

  error(message: string, options?: ExternalToast): string | number {
    return toast.error(message, options);
  }

  success(message: string, options?: ExternalToast): string | number {
    return toast.success(message, options);
  }
}

export const getToasterUtil = (): ToasterUtil => ToasterUtil.instance;
